import actionTypes from '../actiontypes';

class BaseActionCreator {
  static setDefaultDispatcher(dispatcher) {
    BaseActionCreator.dispatcher = dispatcher;
  }

  static getDispatcher() {
    return BaseActionCreator.dispatcher;
  }

  get dispatcher() {
    return BaseActionCreator.getDispatcher();
  }

  dispatch(type, payload) {
    // =========================================================================
    // axios 0.x → 1.x + nock 9.x → 13.x: Guard against undefined dispatcher
    // =========================================================================
    // In axios 0.x, errors were handled synchronously before Jest cleanup.
    // In axios 1.x, error handlers run asynchronously and can execute AFTER
    // Jest has torn down the test environment, when dispatcher is undefined.
    // This guard prevents "Cannot read properties of undefined" crashes.
    // IMPACT: Test environment only - in production, dispatcher is always set.
    // =========================================================================
    if (!this.dispatcher) {
      return undefined;
    }

    if (typeof type === 'object' || typeof type === 'function') {
      return this.dispatcher.dispatch(type);
    }

    return this.dispatcher.dispatch({
      type,
      payload,
    });
  }

  changeUrl(url, state) {
    this.dispatch(actionTypes.APPLICATION.URL_CHANGE, { url, state });
  }

  changeState(redirectResult) {
    this.dispatch(actionTypes.APPLICATION.URL_STATE_CHANGE, { REDIRECT_RESULT: redirectResult });
  }

  handleObligations(obligationData) {
    this.dispatch({
      type: actionTypes.APPLICATION.HANDLE_OBLIGATIONS,
      payload: obligationData,
    });
  }

  clearObligations() {
    this.dispatch({
      type: actionTypes.APPLICATION.CLEAR_OBLIGATIONS,
    });
  }
}
export default BaseActionCreator;
